export default __webpack_public_path__ + "static/media/hsbc.36b5c5e0.svg";